export default __webpack_public_path__ + "static/media/sponsors.ccff8aa6.svg";